import React, { useEffect, useRef, useState } from 'react';
import { useTable, usePagination, useSortBy, useFilters, useGlobalFilter, useAsyncDebounce } from "react-table";
import { PiMicrosoftExcelLogoFill } from 'react-icons/pi';
import { BsPrinter } from 'react-icons/bs';
import ReactHtmlTableToExcel from 'react-html-table-to-excel';
import { CgPushChevronLeft, CgPushChevronRight } from "react-icons/cg";
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import { FaCircleArrowLeft } from 'react-icons/fa6';
import { Col, Row } from 'react-bootstrap';
import { useReactToPrint } from 'react-to-print';

export function CommonReactTable(props) {
    const { columns, data, filename, showFooter, serachAlign, pagination, search, paginationCount, headerName, headColumCount, isBack, isBackFunction, printFalg, excelFlag } = props;
    const calculatedPageSize = paginationCount === "All" ? data?.length : 10;
    const {
        getTableBodyProps,
        headerGroups,
        footerGroups,
        page,
        canPreviousPage,
        canNextPage,
        preGlobalFilteredRows,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex, pageSize },
        setPageSize,
        globalFilter,
        setGlobalFilter,
        rows,
        prepareRow
    } = useTable({
        columns,
        data,

        initialState: { pageIndex: 0, pageSize: calculatedPageSize },

    },

        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination,
    );
    useEffect(() => {
        if (paginationCount === "All") {
            setPageSize(data?.length); // Set to total rows if "All" is selected
        } else {
            setPageSize(10); // Default to 10 rows per page
        }
    }, [paginationCount, data?.length, setPageSize]);

    const [value, setValue] = React.useState(globalFilter)
    const onChange = useAsyncDebounce(valuess => {
        setGlobalFilter(valuess)
    }, 200)
    // let componentRef = useRef();
    // const handleprint = useReactToPrint({
    //     content: () => componentRef.current,
    //     documentTitle: "college-data",
    // });

    const [currentPage, setCurrentPage] = useState(1);
    function rowsCount(a) {
        let countSum = 0
        const rdata = data?.slice(pageIndex * pageSize, (pageIndex + 1) * pageSize);

        if (a?.FooterParamAction) {
            let params1 = a?.Footerparams?.split('-')[0]
            let params2 = a?.Footerparams?.split('-')[1]
            let paramsum1 = rdata?.reduce((sum, row) => sum + row[params1], 0)
            let paramsum2 = rdata?.reduce((sum, row) => sum + row[params2], 0)
            if (a.FooterParamAction === '-') {
                countSum = parseInt(paramsum1) - parseInt(paramsum2)
            }
            else {
                countSum = parseInt(paramsum1) + parseInt(paramsum2)
            }

        }
        else {
            countSum = rdata?.reduce((sum, row) => sum + row[a.Footer], 0)
        }

        if (isNaN(countSum) === false) {
            return countSum
        }
        else {
            return 0
        }
    }
    const printRef = useRef();
    //     const handlePrint = useReactToPrint({
    //     content: () => printRef.current,
    //     documentTitle: "kgbv",
    // });
    const handlePrint = () => {
        const table = printRef.current.querySelector("table");
        const printWindow = window.open("", "_blank");
        printWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
 
        <style>
          @page{
            size: landscape;
            margin:10mm;
          }
 
          html,body{
            margin:0;
            padding:0;
            font-family:Arial,sans-serif;
          }
 
          .no-print{
    display:none !important;
}
          table{
            width:100% !important;
            min-width:0 !important;
            table-layout:auto !important;
            border-collapse:collapse !important;
          }
 
          th,
          td{
            border:1px solid #000 !important;
            padding:5px !important;
            font-size:11px !important;
            white-space:normal !important;
            word-break:break-word;
          }
 
          thead{
            display:table-header-group;
          }
 
          tr{
            page-break-inside:avoid;
          }
        </style>
 
      </head>
 
      <body>
        ${table.outerHTML}
      </body>
 
    </html>
  `);

        printWindow.document.close();

        printWindow.onload = () => {
            printWindow.focus();
            printWindow.print();
            printWindow.close();
        };
    };

    return (
        <React.Fragment>
            <Row className='mt-1 mb-2'>
                <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}
                    className="page-titlespacing d-flex justify-content-between">
                    {search === "false" ? "" :
                        <div className={serachAlign === 'right' ? 'text-end' : "none"}>
                            <span className='me-3'><input value={value || ""} name={`search_${Date.now()}`} onChange={e => { setValue(e.target.value); onChange(e.target.value); }}
                                placeholder="Search" style={{ fontSize: '1.1rem', border: '1' }} />
                            </span>
                            {excelFlag !== false && (<React.Fragment>
                                <ReactHtmlTableToExcel id="test-table-xls-button"
                                    className="pull-right btn btn-sm btn-success" table="table-to-xls"
                                    filename={filename} sheet="tablexls"
                                    buttonText={<PiMicrosoftExcelLogoFill size={20} title="Excel" />} />&nbsp;
                            </React.Fragment>)}
                            {printFalg !== 'false' && (
                                <BsPrinter onClick={() => { handlePrint() }} title="Print" className=" btn btn-primary btn-sm"
                                    style={{ fontSize: '32px' }} />
                            )}
                            &emsp;
                            {isBack == true &&
                                <button type='button' className="btn btn-secondary btn-sm"
                                    onClick={() => { isBackFunction() }}>
                                    <FaCircleArrowLeft size={20} /> Back</button>}
                        </div>}
                </Col>
            </Row>
            <div className="custom-table-scroll-wrapper table-container table-scroll " id='myDiv' ref={printRef} style={{
                overflowX: 'auto',
                WebkitOverflowScrolling: 'touch',
            }}>

                <table className="table table-bordered table-striped  mt-0" style={{
                    minWidth: '900px',
                    whiteSpace: 'nowrap',
                }}
                    id="table-to-xls">
                    <thead className='thead-bg'>
                        {headerName && (
                            <tr className='text-center thead2-bg'>
                                <th colSpan={headColumCount}>{headerName}</th>
                            </tr>)}
                        {headerGroups.map((headerGroup, index) => (
                            <tr key={index} {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers?.map((column, aindex) => (
                                    <th key={aindex} {...column?.getHeaderProps(column?.getSortByToggleProps())}
                                        data-toggle="tooltip" animation="true" title={column?.tooltipmsg}
                                        className={column?.customClassName}
                                        style={{ textAlign: column?.style === 'center' ? 'center' : "none" }}>
                                        {column?.render('Header')}
                                        <span>
                                            {column?.isSorted
                                                ? column?.isSortedDesc
                                                    ? ' 🔽'
                                                    : ' 🔼'
                                                : ''}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()} style={{ fontSize: "12px", whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                        {page.length > 0 ? (
                            page.map((row, index) => {
                                prepareRow(row);
                                return (
                                    <tr {...row.getRowProps()} key={index}>
                                        {row.cells.map((cell, bindex) => {
                                            return <td key={bindex} {...cell.getCellProps()}
                                                className={cell?.column?.customClassName}
                                                style={{ overflowWrap: "break-word", whiteSpace: 'normal' }}>
                                                {cell.render("Cell")}</td>;
                                        })}
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td
                                    colSpan={headerGroups[0]?.headers?.length || 1}
                                    className="text-center"
                                    style={{
                                        padding: "20px",
                                        fontWeight: "600",
                                        color: "#6c757d",
                                    }}
                                >
                                    No Records Found
                                </td>
                            </tr>
                        )}
                    </tbody>
                    {(showFooter === "true" && page.length > 0) ? <tfoot style={{ background: 'azure' }}>
                        <tr>
                            {footerGroups[0].headers.map((column, cindex) => (
                                <td key={cindex} {...column.getFooterProps()}
                                    className={column?.customClassName}
                                    style={{
                                        border: '1px solid lightblue',
                                        cursor: column.isClickable ? 'pointer' : 'auto',
                                        textDecoration: column.isClickable ? 'underline' : null,
                                        color: column.isClickable ? "Highlight" : "none",
                                    }} onClick={() => {
                                        if (column.isClickable) {
                                            column.FooterFunc(); // Call the function on click
                                        }
                                    }}>
                                    {column.Footer === 'Total' ? column.Footer : typeof (column.Footer) === 'string' ? rowsCount(column) : ''}
                                </td>
                            ))}
                        </tr>
                    </tfoot> : null}

                </table>
            </div>
            {pagination === "true" &&
                <div className="pagination mt-2">
                    <button type='button' onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}><CgPushChevronRight size={21} /></button>&emsp;
                    <button type='button' onClick={() => nextPage()} disabled={!canNextPage}><FaChevronRight /></button>&emsp;
                    <button type='button' onClick={() => previousPage()} disabled={!canPreviousPage}><FaChevronLeft /></button>&emsp;
                    <button type='button' onClick={() => gotoPage(0)} disabled={!canPreviousPage}><CgPushChevronLeft size={21} /></button>&emsp;
                    <button type='button' className='mt-1'>&emsp;{currentPage} - <strong>{pageSize}</strong> of <strong>{preGlobalFilteredRows?.length} </strong>  &emsp;</button>
                    <select value={pageSize} onChange={e => {
                        setPageSize(Number(e.target.value)); setCurrentPage(1);
                    }}>
                        <option value={rows.length}>All</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                    </select>
                    Rows per page : &emsp;
                </div>}
        </React.Fragment>
    );
}
